module.exports = __webpack_public_path__ + "static/media/livelihood.b3c57bc4.jpg";